import {assert} from 'Asserts';
import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {makeReactContext} from 'lib/makeReactContext';

export const StepConfigEditorContext = makeReactContext<{dataFrameSpec: DataFrameSpec}>(() => {
  assert(false, 'StepConfigEditorContext not initialized');
}, 'StepConfigEditorContext');

export function useStepConfigEditorContext(): {dataFrameSpec: DataFrameSpec} {
  return StepConfigEditorContext.useContext();
}
